<template>
    <div class="conten">
        <div class="c1">
            <div class="btn-main">
                <Button shape="circle" class="menu-btn" @click="see" :type="this.findData.userid !== ''||this.findData.mobilenum !== ''||this.findData.starttime !== ''||this.findData.endtime !== '' ? 'info' : 'default'">查询</Button>
            </div>
        </div>
        <div class="c2">
            <!-- <div class="table-page-box"> -->
            <Table highlight-row border size="small" v-cloak ref="selection" :columns="columns" :data="data" :max-height="tableHeight"></Table>
            <div class="c4">
            </div>
        </div>
        <div class="c3">
            <Page :current.sync="page" :total="total" :page-size="limit" show-total show-elevator />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            modalManagePwd: true,
            clientHeight: 0,
            tableHeight: 200,
            loading: true,
            // 查询模态框数据
            findData: {
                userid: '',
                mobilenum: '',
                starttime: '',
                endtime: ''
            },
            findmodal: false, // 默认查询模态框不显示
            page: 1, // 默认请求第一页
            limit: 10, // 默认一页请求20条
            total: 20, // 返回总条数
            data: [{
                seqid: 16,
                userid: "Mschen1030",
                userguid: "",
                suggestions: "支持使用在线客服",
                realname: "",
                mobilenum: "17780630465",
                inserttime: "2020-04-15 11:11:24.583",
                rownumber: ""
            }, ], // tbody部分
            columns: [{
                    title: '账号名',
                    minWidth: 200,
                    align: 'center',
                    key: 'userid'
                },
                {
                    title: '电话号码',
                    minWidth: 200,
                    align: 'center',
                    key: 'mobilenum'
                },
                {
                    title: '操作',
                    minWidth: 200,
                    align: 'center',
                    render: function(createElement, params) {
                        const row = params.row;
                        const text = row.suggestions;
                        return createElement('div', {}, [
                            // "查阅了",
                            createElement('Button', {
                                domProps: {
                                    innerHTML: '重置密码', //'<item class="ls" id="112233">' + text + '</item>'
                                },
                                on: {
                                    'click': (value) => {
                                        console.log('1111')
                                        //that.link(value);
                                    }
                                }
                            }, ''),
                        ])
                    }
                }
            ] // theader部分
        }
    },

    mounted() {
        window.onresize = () => {
            //console.log(this.tableHeight)
            this.clientHeight = `${document.documentElement.clientHeight}`; //获取浏览器可视区域高度
            //console.log(this.clientHeight)

            this.tableHeight = this.clientHeight - 180
            //console.log(this.tableHeight)

        }
        // 设置表格高度 
    },
    created() {
        this.clientHeight = `${document.documentElement.clientHeight}`; //获取浏览器可视区域高度
        //console.log(this.clientHeight)

        this.tableHeight = this.clientHeight - 180
    },
    methods: {
        see() {
            //console.log(this.tableHeight)
        },
        //注销window.onresize事件
        destroyed() {
            window.onresize = null;
        }
    }
}
</script>
<style scoped>
.conten {
    height: 100%;
    flex-direction: column;
}

.c1 {
    background-color: #f8f8f9;
    height: 32px;
}

.c3 {
    width: 100%;
    position: fixed;
    bottom: 65px;
    height: 35px;
    border: 1px solid #dcdee2;
    background: #f8f8f9;
}

.c2 {
    flex: 1;
    height: 100%-35px;
    display: flex;
    flex-direction: column;
}
</style>